import styled from 'styled-components';
import theme from '../../theme';

export const UpdateCardContainer = styled.div`
  padding: 0rem 1rem 2rem calc(100px + 6rem);
  width: 100%;
  box-sizing: border-box;
  margin-left: 0;
  transition: padding-left 0.3s ease;
  font-family: 'Gabarito', sans-serif;
  overflow-x: hidden;
  display: flex;
  justify-content: center;
  align-items: stretch;
  min-height: 100vh;
  overflow-y: auto;
`;

export const UpdateCard = styled.div`
  width: 100%;
  border-radius: 20px;
  border: 1px solid #E6E6E6;
  background: #FEFFFE;
  padding: 1.5rem;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
`;

export const CardHeader = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  gap: 1rem;
  margin-bottom: 1rem;
  padding-bottom: 1rem;
`;

export const TitleWrapper = styled.div`
  flex: 2;
  min-width: 250px;
`;

export const EstablishmentWrapper = styled.div`
  flex: 1;
  min-width: 200px;
`;

export const Input = styled.input`
  width: 100%;
  padding: 0.75rem 1rem;
  font-size: 1rem;
  border: 1px solid #E6E6E6;
  border-radius: 10px;
  background: #FEFFFE;
  color: #29435B;
  box-sizing: border-box;
  margin-top: 0.25rem;
  font-family: 'Gabarito', sans-serif;
  outline: none;
  transition: border-color 0.2s ease;

  &:focus {
      border-color: #38B6FF;
  }

  &::placeholder {
    color: #aaa;
  }
`;

export const TextArea = styled.textarea`
  width: 100%;
  padding: 0.75rem 1rem;
  font-size: 1rem;
  border: 1px solid #E6E6E6;
  border-radius: 10px;
  background: #FEFFFE;
  color: #29435B;
  box-sizing: border-box;
  margin-top: 0.25rem;
  min-height: 80px;
  font-family: 'Gabarito', sans-serif;
  resize: vertical;
  outline: none;
  transition: border-color 0.2s ease;

  &:focus {
      border-color: #38B6FF;
  }

  &::placeholder {
    color: #aaa;
  }
`;

export const FormationTitleInput = styled(TextArea)`
  font-weight: 600;
  resize: none;
  overflow-y: hidden;
  height: auto;
  min-height: 1.4em;
  line-height: 1.4;
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
  display: block;
`;

export const FormationTypeInput = styled(TextArea)`
  font-size: 0.9rem;
  font-weight: 500;
  resize: none;
  overflow-y: hidden;
  min-height: 45px;
  height: auto;
  line-height: 1.4;
`;

export const LocationIcon = styled.img`
  width: 20px;
  height: 20px;
  margin-right: 0.5rem;
`;

export const EstablishmentNameInput = styled(Input)`
  font-size: 1rem;
  font-weight: 500;
`;

export const InfoSection = styled.div`
  margin-bottom: 1rem;
  padding-bottom: 1rem;

  &:last-child {
    border-bottom: none;
    margin-bottom: 0;
    padding-bottom: 0;
  }
`;

export const InfoGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 1rem;
`;

export const InfoItem = styled.div`
  display: flex;
  flex-direction: column;
`;

export const InfoLabel = styled.label`
  font-size: 0.9rem;
  font-weight: 600;
  color: #29435B;
  margin-bottom: 0.35rem;
  font-family: 'Gabarito', sans-serif;
`;

export const StyledInput = styled(Input)`
  font-size: 0.9rem;
`;

export const StyledTextArea = styled(TextArea)`
  font-size: 0.9rem;
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
  margin-top: 1.5rem;
  padding-top: 1rem;
`;

export const CancelButton = styled.button`
  width: 235px;
  height: 45px;
  flex-shrink: 0;
  border-radius: 10px;
  border: 1px solid #E6E6E6;
  background: #FFF;
  color: #38B6FF;
  font-family: 'Gabarito', sans-serif;
  font-size: 1rem;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  cursor: pointer;
  transition: background-color 0.2s ease, color 0.2s ease, border-color 0.2s ease;

  &:hover {
      background-color: #f5f5f5;
      border-color: #ccc;
  }

  &:disabled {
      background-color: #eee;
      color: #aaa;
      cursor: not-allowed;
      border-color: #ddd;
  }
`;

export const ConfirmButton = styled.button`
  width: 235px;
  height: 45px;
  flex-shrink: 0;
  border-radius: 10px;
  background: #38B6FF;
  border: none;
  color: #FFF;
  font-family: 'Gabarito', sans-serif;
  font-size: 1rem;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  cursor: pointer;
  transition: background-color 0.2s ease;

  &:hover {
      background-color: ${theme.colors.bleu_fonce};
  }

  &:disabled {
      background-color: #a0d8ff;
      cursor: not-allowed;
  }
`;

export const ErrorMessage = styled.div`
  color: #e74c3c;
  margin-top: 1rem;
  padding: 0.5rem;
  background-color: #fde8e8;
  border-radius: 4px;
  text-align: center;
`;

export const SuccessMessage = styled.div`
  color: #2ecc71;
  margin-top: 1rem;
  padding: 0.5rem;
  background-color: #e8fde8;
  border-radius: 4px;
  text-align: center;
`;

export const StyledSelect = styled.select`
  width: 100%;
  padding: 0.75rem 1rem;
  font-size: 0.9rem;
  border: 1px solid #E6E6E6;
  border-radius: 10px;
  background: #FEFFFE;
  color: #29435B;
  box-sizing: border-box;
  margin-top: 0.25rem;
  font-family: 'Gabarito', sans-serif;
  outline: none;
  appearance: none;
  background-image: url('data:image/svg+xml;charset=US-ASCII,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%22292.4%22%20height%3D%22292.4%22%3E%3Cpath%20fill%3D%22%2329435B%22%20d%3D%22M287%2069.4a17.6%2017.6%200%200%200-13-5.4H18.4c-5%200-9.3%201.8-12.9%205.4A17.6%2017.6%200%200%200%200%2082.2c0%205%201.8%209.3%205.4%2012.9l128%20127.9c3.6%203.6%207.8%205.4%2012.8%205.4s9.2-1.8%2012.8-5.4L287%2095c3.5-3.5%205.4-7.8%205.4-12.8%200-5-1.9-9.2-5.5-12.8z%22%2F%3E%3C%2Fsvg%3E');
  background-repeat: no-repeat;
  background-position: right 1rem center;
  background-size: 0.65em auto;
  cursor: pointer;

  &:focus {
      border-color: #38B6FF;
  }
`;

export const ExtendedTextArea = styled(StyledTextArea)`
  min-height: 120px;
  height: auto;
  resize: none;
  line-height: 1.4;
  padding-bottom: 1.2rem;
`;

export const CheckboxGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

export const CheckboxItem = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
`;

export const CheckboxLabel = styled.label`
  margin-left: 0.5rem;
  font-size: 0.9rem;
  color: #29435B;
  cursor: pointer;
`;

export const CheckboxInput = styled.input.attrs({ type: 'checkbox' })`
  cursor: pointer;
`;

export const SelectedDomainsDisplay = styled.div`
  width: 100%;
  padding: 0.75rem 1rem;
  font-size: 0.9rem;
  border: 1px solid #E6E6E6;
  border-radius: 10px;
  background: #FEFFFE;
  color: #29435B;
  box-sizing: border-box;
  min-height: 40px;
  cursor: pointer;
  display: flex;
  align-items: center;
  position: relative;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  &::after {
    content: '';
    position: absolute;
    right: 1rem;
    top: 50%;
    transform: translateY(-50%);
    width: 0;
    height: 0;
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-top: 5px solid #29435B;
  }
`;

export const DropdownContent = styled.div`
  position: absolute;
  top: calc(100% + 5px);
  left: 0;
  right: 0;
  background: #FFF;
  border: 1px solid #E6E6E6;
  border-radius: 10px;
  padding: 0.75rem;
  z-index: 10;
  box-shadow: 0 4px 8px rgba(0,0,0,0.1);
  max-height: 200px;
  overflow-y: auto;
`;

export const InputWithPercentage = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem; // Space between input and %

  input {
    max-width: 80px; // Limit the width of the number input
    flex-grow: 0; // Prevent input from growing
    flex-shrink: 0; // Prevent input from shrinking unnecessarily
  }

  span {
    flex-shrink: 0; // Ensure the % sign doesn't get pushed away if space is tight
  }
`; 